import * as React from 'react'
import * as Reakit from 'reakit/Menu'

/**
 * When rendering multiple dropdowns, wrap them in `DropdownBar` so they can be
 * navigated between
 */
export function DropdownBar({ children, ...props }: Partial<Reakit.MenuBarProps>) {
  const state = Reakit.useMenuBarState()

  return (
    <Reakit.MenuBar {...state} {...props}>
      {React.Children.map(children, (child) => {
        if (!React.isValidElement(child)) return child

        return (
          <Reakit.MenuItem {...state} {...child.props}>
            {(itemProps) => React.cloneElement(child, itemProps)}
          </Reakit.MenuItem>
        )
      })}
    </Reakit.MenuBar>
  )
}
